export const selectPosts = (reduxState) => reduxState.posts.posts;
export const selectPhotos = (reduxState) => reduxState.posts.photos;

export const selectRestaurants = (reduxState) => reduxState.posts.restaurants;

export const selectNews = (reduxState) => reduxState.posts.news;
